import { useEffect, useState } from "react";
import { adminApproveWall, adminRejectWall, adminWall, type AdminWallPost } from "../../lib/api";
import { useI18n } from "../../i18n";
import { Check, X } from "../Icon";

export function WallTab() {
  const { t } = useI18n();
  const [status, setStatus] = useState("pending");
  const [posts, setPosts] = useState<AdminWallPost[]>([]);
  const [loading, setLoading] = useState(false);

  function load() {
    setLoading(true);
    adminWall(status)
      .then(setPosts)
      .catch(() => {})
      .finally(() => setLoading(false));
  }
  useEffect(load, [status]); // eslint-disable-line react-hooks/exhaustive-deps

  async function act(id: string, fn: (id: string) => Promise<unknown>) {
    setPosts((p) => p.filter((x) => x.id !== id));
    try {
      await fn(id);
    } catch {
      load();
    }
  }

  const tabs = [
    { v: "pending", label: t("admin.pending") },
    { v: "approved", label: t("admin.approved") },
    { v: "rejected", label: t("admin.rejected") },
  ];

  return (
    <div>
      <div className="inline-flex gap-1 rounded-full bg-white/70 p-1 ring-1 ring-black/5">
        {tabs.map((tab) => (
          <button
            key={tab.v}
            onClick={() => setStatus(tab.v)}
            className={`rounded-full px-4 py-1.5 text-sm font-semibold ${
              status === tab.v ? "bg-[var(--theme-main)] text-white" : "text-ink/60"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {!loading && posts.length === 0 && (
        <p className="mt-8 text-center text-ink/50">{status === "pending" ? t("admin.noPending") : "—"}</p>
      )}

      <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {posts.map((p) => (
          <div key={p.id} className="rounded-2xl bg-white/80 p-3 shadow-card ring-1 ring-black/5">
            {p.has_image && (
              <img src={`/api/admin/wall/img/${p.id}`} alt="" className="mb-2 max-h-72 w-full rounded-xl object-cover" />
            )}
            {p.message && <p className="whitespace-pre-wrap text-sm text-ink/80">{p.message}</p>}
            {p.display_name && <p className="mt-1 text-xs font-semibold text-[var(--theme-deep)]">— {p.display_name}</p>}
            <div className="mt-3 flex gap-2">
              {status !== "approved" && (
                <button
                  onClick={() => act(p.id, adminApproveWall)}
                  className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-lg bg-green-500 py-2 text-sm font-bold text-white"
                >
                  <Check className="h-4 w-4" /> {t("admin.approve")}
                </button>
              )}
              {status !== "rejected" && (
                <button
                  onClick={() => act(p.id, adminRejectWall)}
                  className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-lg bg-red-100 py-2 text-sm font-bold text-red-600"
                >
                  <X className="h-4 w-4" /> {t("admin.reject")}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
